import axios from 'axios';
import { useEffect, useState } from 'react';

import { useAuth } from '@providers/AuthProvider';

import selfie from '@assets/vectors/selfie.svg';
import upload from '@assets/vectors/upload.svg';
import { ApiEndpoints } from '@utils/endpoints';

interface IFetchPhoto {
	imageType: 'Selfie' | 'Photo ID';
	handleError?: (error: any) => void;
	defaultReturn?: boolean;
	callback?: (photoData?: string) => void;
}

type FetchPhotoFunction = ({ imageType, handleError, defaultReturn, callback }: IFetchPhoto) => {
	photo: string;
};

const useFetchPhoto: FetchPhotoFunction = ({
	callback = () => {},
	defaultReturn = true,
	imageType,
	handleError = () => {},
}) => {
	const [photo, setPhoto] = useState<string>('');

	const { initialized, getAuthToken } = useAuth();

	const getEndpoint = () => {
		const endpoints = { Selfie: 'selfie', 'Photo ID': 'id' };
		return `/image/${endpoints[imageType]}Image`;
	};

	const getPlaceholder = () => {
		const placeholders = { Selfie: selfie, 'Photo ID': upload };
		return placeholders[imageType];
	};

	useEffect(() => {
		if (!initialized) return;
		async function fetchPhoto() {
			const authorizationToken = await getAuthToken();
			const endpoint = getEndpoint();
			axios
				.get(`${ApiEndpoints.memberPortal}${endpoint}`, {
					headers: {
						Accept: 'image/png, image/jpeg, image/gif, application/pdf',
						authorizationToken,
					},
					responseType: 'blob',
				})
				.then(({ data }) => {
					const photoData = URL.createObjectURL(data);
					setPhoto(photoData);
					callback(photoData);
				})
				.catch((error: any) => {
					defaultReturn && setPhoto(getPlaceholder);
					handleError(error);
				});
		}

		fetchPhoto();

		// Cleaning up after ourselves
		return function cleanup() {
			URL.revokeObjectURL(photo);
		};
	}, [initialized]);

	return { photo };
};

export default useFetchPhoto;
